import React from 'react'
import styled from 'styled-components'
import { PlacableModuleData } from '../../../types/ModuleData'
import CloneDraggable from '../dnd/CloneDraggable'
import getDragType from '../dnd/getDragType'
import Icon from '../Icon'
import PreviewModule from '../preview/PreviewModule'

const SidebarModuleButtonInner = styled.div`
  font-size: 12px;
  line-height: 1.4;
  background-color: #f2f2f2;
  padding: 20px;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  box-shadow: 0px 2px 5px #00000000;
  transition: box-shadow 0.2s;
`

const SidebarModuleButtonLabel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  b {
    display: block;
    font-size: 15px;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const SidebarModuleButtonHandle = styled.div.attrs({
  children: <Icon name="move-square" />
})`
  margin-left: 20px;
  width: 56px;
  height: 56px;
  background: #fff;
  border-radius: 2px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
  transition: background-color 0.2s, color 0.2s;

  ${Icon} {
    font-size: 20px;
  }
`

const SidebarModuleButtonImage = styled.div<{ src: string }>`
  width: 56px;
  height: 56px;
  background-image: url('${(props) => props.src}');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin-right: 20px;
`

export type SidebarModuleButtonProps = {
  module: PlacableModuleData
}
const SidebarModuleButton = React.memo(styled<React.FC<SidebarModuleButtonProps>>(function SidebarModuleButton({
  module,
  ...props
}) {
  return (
    <div {...props}>
      <CloneDraggable
        draggableId={module.id}
        type={getDragType(module)}
        renderClone={() => <PreviewModule module={module} />}
      >
        <SidebarModuleButtonInner>
          <SidebarModuleButtonImage src={(('thumbnail' in module && module.thumbnail) || module.preview).url} />
          <SidebarModuleButtonLabel>
            <b>{module.title}</b>
          </SidebarModuleButtonLabel>
          <SidebarModuleButtonHandle />
        </SidebarModuleButtonInner>
      </CloneDraggable>
    </div>
  )
})<SidebarModuleButtonProps>`
  position: relative;
  display: block;
  border-radius: 2px;

  &:hover {
    ${SidebarModuleButtonInner} {
      box-shadow: 0px 2px 5px #00000065;
    }

    ${SidebarModuleButtonHandle} {
      background-color: #cf0000;
      color: #fff;
    }
  }
`)

export default SidebarModuleButton
